import React from "react";
import PropTypes from "prop-types";
import {FormattedMessage, useIntl} from "react-intl";

import {
    Box,
    Table,
    TableBody,
    TableHead,
} from "@mui/material";

import TopTableHeader from "../../../TopTablesComponents/TopTableHeader";
import TopTableLoader from "../../../TopTablesComponents/TopTableLoader";
import StockAlertRow from "./components/StockAlertRow";

import {greyishBlue500} from "assets/jss/main";
import RankHeaderLabel from "../../../TopTablesComponents/RankHeaderLabel";

function StockAlertsTable({data, loading, currency, sortMode}) {
    const intl = useIntl();

    if (loading) {
        return <TopTableLoader />
    }

    const rawProducts = data?.products ?? [];

    if (!rawProducts.length) {
        return (
            <div style={{color: greyishBlue500, fontSize: "14px", padding: "32px 0", textAlign: "center"}}>
                <FormattedMessage id="dashboard.productsRanking.table.no_result"/>
            </div>
        );
    }

    const products = [...rawProducts].sort((a, b) => {
        if (sortMode === 1) {
            return (b.alerts ?? 0) - (a.alerts ?? 0);
        }

        return (b.lostRevenue ?? 0) - (a.lostRevenue ?? 0);
    });

    const headers = [
        { label: <RankHeaderLabel>{intl.formatMessage({ id: "dashboard.table.header.rank" })}</RankHeaderLabel>, align: "left" },
        {label: <FormattedMessage id="dashboard.stockAlerts.table.header.alerts"/>, align: "left"},
        {label: <FormattedMessage id="dashboard.stockAlerts.table.header.lostRevenue"/>, align: "left"},
        {label: <FormattedMessage id="dashboard.stockAlerts.table.header.variantsDemanded"/>, align: "left"},
        {label: <FormattedMessage id="dashboard.stockAlerts.table.header.descriptionRef"/>, align: "left"},
        {label: <FormattedMessage id="dashboard.stockAlerts.table.header.priority"/>, align: "center"},
    ];

    return (
        <Box sx={{ overflowX: "auto" }}>
            <Table size="small" sx={{ minWidth: 600 }}>
                <TableHead>
                    <TopTableHeader headers={headers} />
                </TableHead>
                <TableBody>
                    {products.map((product, index) => (
                        <StockAlertRow
                            key={product.id ?? index}
                            rank={index + 1}
                            product={product}
                            currency={currency}
                        />
                    ))}
                </TableBody>
            </Table>
        </Box>
    );
}

StockAlertsTable.propTypes = {
    data: PropTypes.object,
    loading: PropTypes.bool,
    currency: PropTypes.string,
    sortMode: PropTypes.oneOf([0, 1]),
};

export default StockAlertsTable;
